import apiConfig from "../config/api";
import { get, post } from "../helpers/request";

const parameters = `${apiConfig.apiUri}api/parameters`;
const sucursalesUrl = `${apiConfig.apiUri}api/company/get`;
const siniestrosUrl = `${apiConfig.apiUri}api/losses`;
const complaints = `${apiConfig.apiUri}api/complaints`;

const powerBi = `${apiConfig.apiUri}api/user`;

export const listaProfesionales = () => get(`${parameters}/profesionales`);

export const listaEstadoCivil = () => get(`${parameters}/estadoCivil`);

export const listaRegiones = () => get(`${parameters}/regiones`);

export const listaComunas = () => get(`${parameters}/comunas`);

export const listaAfp = () => get(`${parameters}/afp`);

export const listaRubros = () => get(`${parameters}/rubros`);

export const listaJornadas = () => get(`${parameters}/jornadas`);

export const listaBancos = () => get(`${parameters}/bancos`);

export const listaParentesco = () => get(`${parameters}/parentescos`);

export const listaSucursales = (idEmpresa) => get(`${sucursalesUrl}/offices/${idEmpresa}`);

export const listaSexos = () => get(`${parameters}/sexos`);

export const listaNacionalidades = () => get(`${parameters}/nacionalidades`);

export const listaPueblosOriginarios = () => get(`${parameters}/pueblosOriginarios`);

export const listaTiposCalle = () => get(`${parameters}/tiposCalle`);

export const listaClasificacionesAccidente = () => get(`${parameters}/clasificacionesAccidente`);

export const listaMediosPrueba = () => get(`${parameters}/mediosPrueba`);

export const listaTiposCuenta = () => get(`${parameters}/tipoCuentas`);

export const listaTiposContrato = () => get(`${parameters}/tipoContrato`);

export const listaCategoriasOcupacionales = () => get(`${parameters}/categoriaOcupacional`);

export const listaTiposIngreso = () => get(`${parameters}/tipoIngreso`);

export const listaDirecciones = () => get(`${parameters}/direcciones`);

export const listaIsapres = () => get(`${parameters}/Isapres`);

export const listaTiposDenuncias = () => get(`${complaints}/complaintsType`);

export const listaOcupaciones = () => get(`${parameters}/occupations`);

export const GetTokenPowerBi = (groupId, reportId) => get(`${powerBi}/GetEmbedToken/${groupId}/${reportId}`);

export const getTipoSiniestros = () => get(`${siniestrosUrl}/typeLosses`);

export const getEstadosDocumentacion = () => get(`${siniestrosUrl}/financialbenefits/documentationState`);

export const getTipoPrestaciones = () => get(`${siniestrosUrl}/financialbenefits/financialBenefitType`);

export const getEstadosPago = () => get(`${siniestrosUrl}/financialbenefits/statePaymentFinancialBenefit`);

export const getParametersListByName = (listaParameters) => post(
  `${parameters}/getManyParametersByName`,
  {
    body: JSON.stringify(listaParameters),
  }
);

